import React from "react";
import styles from "./Invite.module.scss";
import TextInput from "../TextInput";
import { Submit } from "../Submit";
import { LogoContainer } from "../LogoContainer";
import { ActionLink } from "../ActionLink";
import Gallery from "../../types/Gallery";
import useInvite from "../../hooks/useInvite";
import World from "../../world";

type Props = {
    world: World;
    gallery: Gallery;
}
export const InviteGuestsForm = (props: Props) => {
    const {
        onChange,
        onSubmit,
        isPending,
        error
    } = useInvite(props.world, props.gallery.name, props.gallery.id());

    return (
        <div className={styles["invite-form"]}>
            <LogoContainer />

            <h1>Invite Your Guest</h1>

            <p>Your guest will receive a text message from your gallery's phone number with a link to your gallery</p>

            {error && (
                (error.status === 409 ? (
                    <p><span className="form-error">Contact already added to gallery</span></p>
                ) : (
                    <p><span className="form-error">{error.message}</span></p>
                ))
            )}

            <form onSubmit={onSubmit}>
                <TextInput
                    name="phone"
                    placeholder="555-555-5555"
                    help="Guest's Phone Number"
                    required
                    nocomplete
                    onChange={onChange} />

                <TextInput
                    name="full_name"
                    placeholder="Guest Name"
                    help="Guest's Displayed Name"
                    nocomplete
                    onChange={onChange} />

                <Submit label="Send" is_pending={isPending} />

                <ActionLink to={`/dashboard/galleries/${props.gallery.id()}`}>
                    cancel
                </ActionLink>
            </form>
        </div>
    );
};

export default InviteGuestsForm;
